export const moneyFormat = (value: number, currency: string) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
  }).format(value);

export const formatUSD = (value: number, showCents: boolean = true) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    ...(showCents
      ? {}
      : { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
  }).format(value);
